import React from "react";
import { useShallow } from "zustand/react/shallow";
import {
    RoomPlayer,
    Card,
    GameConstant,
} from "@uno/protocol";
import useStoreRoomPlayer from "../../../store/useStoreRoomPlayer";
import useStoreAnimation from "../../../store/useStoreAnimation";
import useStoreRoomScene from "../../../store/useStoreRoomScene";
import DrawCardFromDeckAnimation from "../../../animation/DrawCardFromDeckAnimation";

const useRoomPlayerDrawCard = () => {
    const addCardToRoomScene = useStoreRoomScene(useShallow(state => state.add));
    const enqueueAnimation = useStoreAnimation(useShallow(state => state.enqueue));

    return React.useCallback(({ roomPlayer: originRoomPlayer, card, position }: { roomPlayer: RoomPlayer, card: Card, position: number }, order: number = 0) => {
        const myPlayerId = useStoreRoomPlayer.getState().roomPlayer?.player?.id;
        const isMe = myPlayerId === originRoomPlayer.player.id;
        const finalPosition = isMe ? position : Math.min(GameConstant.startingCardsCount, originRoomPlayer.cards.length);
        const { initial, effects, transitions, duration, onAnimationEnd } = DrawCardFromDeckAnimation(isMe, order);

        addCardToRoomScene(originRoomPlayer.player.id, finalPosition, { id: card.id, type: "BACK", canBePut: false, isHoverable: false });
        enqueueAnimation(card.id, { name: "room-player-drawn-card", initial, effects, transitions, duration, onAnimationEnd });
    }, []);
}

export default useRoomPlayerDrawCard;
